(function () {
  function reveal(section) {
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-revealed');
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('is-revealed');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(section);
  }

  function setupAccordion(section) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    section.classList.add('js-accordion');
    section.querySelectorAll('.ibscent-contact__faq-item').forEach((item) => {
      const summary = item.querySelector('summary');
      const body = item.querySelector('.ibscent-contact__faq-a');
      if (!summary || !body || item.dataset.accInit) return;
      item.dataset.accInit = '1';
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(() => { body.style.height = '0px'; });
          body.addEventListener('transitionend', function done() {
            item.open = false;
            body.style.height = '';
            body.removeEventListener('transitionend', done);
          }, { once: true });
        } else {
          item.open = true;
          body.style.height = '0px';
          const target = body.scrollHeight;
          requestAnimationFrame(() => { body.style.height = target + 'px'; });
          body.addEventListener('transitionend', function done() {
            body.style.height = '';
            body.removeEventListener('transitionend', done);
          }, { once: true });
        }
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.ibscent-contact').forEach((section) => {
      if (section.dataset.revealInit) return;
      section.dataset.revealInit = '1';
      reveal(section);
      setupAccordion(section);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', () => init());
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
